import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { CoreService } from "@assoanalytics/app/core/services/core.service";
import { AppSettings } from "@assoanalytics/app/core/models/app-settings";

@Component({
  selector: "app-blank",
  imports: [RouterModule, CommonModule],
  templateUrl: "./blank.component.html",
  styleUrls: [],
})
export class BlankComponent {
  private htmlElement!: HTMLHtmlElement;

  options = this.settings.getOptions();

  constructor(private settings: CoreService) {
    this.htmlElement = document.querySelector("html")!;
    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === "dark") {
      this.htmlElement.classList.add("dark-theme");
      this.htmlElement.classList.remove("light-theme");
    } else {
      this.htmlElement.classList.remove("dark-theme");
      this.htmlElement.classList.add("light-theme");
    }
  }
}
